<template>
  <v-container :class="setContainer">
    <div v-if="pdfs == null || pdfs.length == 0">
      <v-row class="ma-0" align="center" justify="center">
        <v-icon class="mx-auto" color="#E1E2E6" size="200px">picture_as_pdf</v-icon>
      </v-row>
      <v-row class="ma-0" align="center" justify="center">
        <div class="font-weight-bold no-data">ไม่มีไฟล์ให้แสดง</div>
      </v-row>
    </div>

    <div v-show="pdfs !== null && pdfs.length>0">
      <v-list two-line subheader>
        <v-list-item v-for="pdf in pdfs" :key="pdf._id" @click="changeStatus(pdf.pdf.url)">
          <v-list-item-avatar>
            <v-icon class="mx-auto" color="black" size="20px">picture_as_pdf</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="pdf.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <div class="notification-container dismiss styleCard">
        <div class="pa-2 btnBack" @click="goBack">
          <v-icon class="mx-auto px-2" color="black" size="20px">mdi-arrow-left</v-icon>Back
        </div>
        <iframe :class="setIframe" :src="pdfShow"></iframe>
      </div>
    </div>
  </v-container>
</template>

<script>
import $ from "jquery";
// import pdf from 'vue-pdf';
export default {
  data() {
    return {
      showPDF: false,
      pdfShow: "",
      setbool: false,
      setContainer: "",
      setIframe: ""
    };
  },
  components: {
    // pdf
  },
  props: {
    pdfs: {
      type: Array
    }
  },
  async mounted() {
    // console.log(this.pdfs);
  },
  methods: {
    goBack() {
      this.setbool = false;
      this.setContainer = "unSetHeightContainer";
      this.setIframe = "iframePDFLive";
      if ($(".notification-container").hasClass("selected")) {
        $(".notification-container")
          .removeClass("selected")
          .addClass("dismiss");
      }
    },
    changeStatus(url) {
      this.setContainer = "setHeightContainer";
      this.setIframe = "iframePDFLive";
      this.setbool = true;
      this.pdfShow = url;
      if ($(".notification-container").hasClass("dismiss")) {
        $(".notification-container")
          .removeClass("dismiss")
          .addClass("selected")
          .show();
      }
    },

    openNewWeb(url) {
      window.open(
        url,
        "vuetifyjs",
        "resizable,scrollbars,status,width=1000,height=700"
      );
    }
  }
};
</script>
<style scoped>
.btnBack:hover {
  cursor: pointer;
}

.styleCard {
  border-radius: 0px !important;
}
.description {
  font-size: 16px;
}
.no-data {
  color: #e1e2e6;
}
.chat-avatar {
  padding: 10px 10px 10px 0px;
  display: inline-table;
}
.chat-message {
  padding: 10px;
  display: inline-table;
  font-size: 16px;
  /* width: 50px; */
}
.box-disable {
  background-color: #f4f4f4;
  vertical-align: center;
  width: 100%;
  height: 100%;
  margin: auto;
  /* width: 60%; */
  /* border: 3px solid #73AD21; */
  padding: 6px;
}
.white-text-btn {
  color: white;
}
.notification-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  /* display: none; */
  height: 100%;
  overflow: hidden;
  background: white;
  z-index: 999;
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
}
.selected {
  display: block;
  animation: slide-in 0.3s forwards;
  -webkit-animation: slide-in 0.3s forwards;
}
.dismiss {
  animation: slide-out 0.3s forwards;
  -webkit-animation: slide-out 0.3s forwards;
  z-index: 0;
  /* display: none; */
}
@media only screen and (max-width: 600px) {
  .setHeightContainer {
    min-height: 500px;
  }
  .unSetHeightContainer {
    min-height: unset !important;
  }
  .iframePDFLive {
    width: 100%;
    min-height: 450px;
  }
}
@media only screen and (min-width: 601px) and (max-width: 960px) {
  .setHeightContainer {
    min-height: 900px;
  }
  .unSetHeightContainer {
    min-height: unset !important;
  }
  .iframePDFLive {
    width: 100%;
    min-height: 850px;
  }
}
@media only screen and (min-width: 961px) {
  .setHeightContainer {
    min-height: 1000px;
  }
  .unSetHeightContainer {
    min-height: unset !important;
  }
  .iframePDFLive {
    width: 100%;
    min-height: 950px;
  }
}
</style>